import uibModalModule from 'angular-ui-bootstrap/src/modal';

import tpl from './logout.tpl.html';
import normalButtonComponentMod from '../../../common/material-components/buttons/normal-button.component';

/**
 * Modal for logout confirmation
 */
class LogoutModalController {
  constructor($uibModalInstance) {
    'ngInject';

    this.$uibModalInstance = $uibModalInstance;
  }

  submit() {
    this.$uibModalInstance.close();
  }

  close() {
    this.$uibModalInstance.dismiss();
  }
}

const config = {
  templateUrl: tpl,
  controller: LogoutModalController,
  controllerAs: '$ctrl',
  size: 'sm'
};

const mod = angular.module('app.auth.modals.logoutModal', [uibModalModule, normalButtonComponentMod])

.factory('openLogoutModal', function ($uibModal) {
  return () => $uibModal.open(config);
});

export default mod.name;
